import Phaser from 'phaser';


class LoadingScene extends Phaser.Scene {

    constructor(config) {
        super('LoadingScene');
        this.config = config;
    }

    preload() {
        console.log('LoadingScene preload is called');
    }

    create() {
        console.log('LoadingScene started.');
        this.scene.start('PageScene');
    }

    update() {

    }

}


export default LoadingScene;